<!--RLV:06Jul2022-->

<template>
    <div>
        <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
            <template v-slot:item="props">
                <tr>
                    <td v-for="(header, index) in headers"
                        :key="index"
                        :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)">
                        <span>{{ props.item[header.value] }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        props: {
            items: {
                default: () => [],
                type: Array
            },
            properties: {
                default: () => [],
                type: Array
            }
        },
        data: () => ({
            headers: [
                {
                    text: "ES grouping",
                    value: "esGrpCode",
                    sortable: false
                },
                {
                    text: "Employee group",
                    value: "grpCode",
                    sortable: false
                },
                {
                    text: "Employee subgroup",
                    value: "locId",
                    sortable: false
                },
                {
                    text: "Name of EE subgroup",
                    value: "grpDesc",
                    sortable: false
                },
                {
                    text: "Name of employee grp",
                    value: "locName",
                    sortable: false
                },
            ]
        }),
        computed: {},
        methods: {
            propRequired(prop, index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property.toLowerCase() == prop.toLowerCase() &&
                        item.index == index &&
                        item.mode == "ESGROUPING"
                    );
                });

                if (result.length > 0) return "red lighten-1";
                else return "";
            },
            all(index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property == "ALL" && item.mode == "ESGROUPING" && item.index == index
                        //item.mode == "PAYLOC" && item.index == index
                    );
                });
                if (result.length > 0) return true;
                else false;
            }
        }
    };
</script>
